
import { useState } from "react";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button"; 
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { RichTextEditor } from "@/components/test-creator/RichTextEditor";
import { useNavigate } from "react-router-dom";
import { FileText } from "lucide-react";

export default function JobCreate() {
  const navigate = useNavigate();
  const [jobTitle, setJobTitle] = useState("");
  const [jobDescription, setJobDescription] = useState("");

  const handleSubmit = () => {
    navigate('/test-creator', {
      state: {
        jobDetails: {
          title: jobTitle,
          description: jobDescription,
          // Other fields will be empty/default
        }
      }
    });
  };

  return (
    <div className="container max-w-7xl mx-auto py-8 px-6 md:px-12 lg:px-24">
      <Card className="p-6">
        <h1 className="text-2xl font-bold mb-6">Create Test</h1>
        
        <div className="space-y-6">
          <div className="space-y-2">
            <Label htmlFor="title">Job Title</Label>
            <Input 
              id="title" 
              value={jobTitle}
              onChange={(e) => setJobTitle(e.target.value)}
              placeholder="Enter job title"
              dir="ltr"
            />
          </div>

          <div className="space-y-2">
            <Label htmlFor="description" className="flex items-center gap-2">
              <FileText className="h-4 w-4" />
              Role Description
            </Label>
            <RichTextEditor 
              value={jobDescription}
              onChange={setJobDescription}
              placeholder="Enter complete job description including responsibilities..."
            />
          </div>

          <div className="flex justify-end space-x-2">
            <Button 
              variant="outline" 
              onClick={() => navigate('/job')}
            >
              Cancel
            </Button>
            <Button 
              onClick={handleSubmit}
              disabled={!jobTitle || !jobDescription}
            >
              Continue
            </Button>
          </div>
        </div>
      </Card>
    </div>
  );
}
